import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Математика. 10-11 класс",
        subject: "Геометрические задачи: акценты формирования  у обучающихся умений поиска решения задач",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Геометрические задачи: акценты формирования  у обучающихся умений поиска решения задач",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Алексеева Елена Евгеньевна",
                grade: "кандидат педагогических наук, доцент, старший научный сотрудник лаборатории математического общего образования ФГБНУ «ИСРО»",
                subGrade: "",
                imageSrc: "./images/author1.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: `<div style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>
                                <p>В содержание учебного предмета «Математика» на уровне среднего общего образования включён учебный курс «Геометрия», который посвящён стереометрии. Основными содержательными линиями курса в 10–11 классах являются «Прямые и плоскости в пространстве», «Многогранники», «Тела вращения», «Векторы и координаты в пространстве», «Движения в пространстве», результаты освоения которых ориентированы на базовый и углублённый уровни. Это зафиксировано в примерных рабочих программах среднего общего образования базового и углублённого уровня.  </p>
                                </div>
                                 <div style='padding: 2.4rem;'>
                                    <p>Кроме того, в контрольно-измерительные материалы государственной итоговой аттестации в форме единого государственного экзамена базового и профильного уровней включены планиметрические и стереометрические задачи разного уровня сложности. Поэтому изучение школьниками геометрии в 10–11 классах должно обеспечивать сформированность умений решения задач на доказательство математических отношений и нахождение геометрических величин, применяя известные методы при решении геометрических задач повышенного и высокого уровня сложности. </p>
                                    <br><p>Решение стереометрических задач – новый вид деятельности для учеников в 10 классе. Поэтому важно с первых уроков изучения геометрии в 10 классе начать целенаправленную работу, способствующую формированию у школьников умений решения стереометрических задач. Это обусловливает актуальность темы «Геометрические задачи: акценты формирования у обучающихся умений поиска решения задач, 10 класс».</p>
                                    <br><p>Поэтому первостепенными вопросами для учителя математики в этом направлении становятся:</p>
                                    <ul>
                                    <li>Какие особенности необходимо учитывать при организации изучения теоретического материала курса «Геометрия» в 10 классе?</li>
                                    <li>Какие методы и приёмы целесообразно использовать в направлении формирования умений решения геометрических задач, в частности стереометрических?</li>
                                    <li>Как в начале изучения геометрии в 10 классе организовать процесс формирования у обучающихся умений решения стереометрических задач?</li>
                                    </ul>
                                    <br><p>В методическом кейсе представлены особенности изучения теоретического материала по геометрии; рассматриваются эвристические приёмы, используемые при поиске решения геометрических задач; даны рекомендации по организации процесса формирования умений поиска решения геометрических задач. </p>
                                    <br><p>Кейс расширен дополнительными учебными материалами, которые учитель математики может использовать в урочной или внеурочной деятельности для организации процесса формирования умений поиска решения геометрических задач.</p>
                                    <br><p>Методический кейс представляет интерес для широкого круга специалистов в области математического образования: учителей, преподавателей педагогических вузов, методистов системы повышения квалификации учителей, студентов и аспирантов педагогических вузов.</p>
                                    </div>`
                        }
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video.mp4",
            contentBefore: [{
                type: "text",
                text: `<p>Структура учебного предмета «Математика», в соответствии Стандартам среднего общего образования в 10–11 классах, представлена тремя отдельными учебными курсами. </p>
<p>Учебный курс «Геометрия» общего образования состоит из двух, логически связанных частей. Изучение геометрии в 10–11 классах посвящено второй части элементарной геометрии – стереометрии.</p>
<p>Поэтому появляется ряд особенностей, которые надо учесть учителю математики при организации процесса изучения стереометрии.</p>
<p><table>
<tr>
<td><img src="./images/pic_1.png"></td>
<td><img src="./images/pic_2.png"></td>
<td><img src="./images/pic_3.png"></td>
</tr>
</table>
</p>
<p><span style="font-style: italic">Первая особенность</span> связана со спецификой этой части элементарной геометрии, которая заключена в том, что стереометрия изучает фигуры и математические отношения между фигурами в пространстве.</p>
<p><table>
<tr>
<td><img src="./images/pic_4.png"></td>
<td><img src="./images/pic_5.png"></td>
<td><img src="./images/pic_6.png"></td>
</tr>
</table>
</p>
<p><table>
<tr>
<td><img src="./images/pic_7.png"></td>
<td><img src="./images/pic_8.png"></td>
<td><img src="./images/pic_9.png"></td>
</tr>
</table>
</p>
<p><span style="font-style: italic">Вторая особенность</span> относится к пространственному мышлению, которое обеспечивает создание трёхмерных образов и действий с ними в процессе решения стереометрических задач. При изучении планиметрии обучающиеся привыкают рассматривать геометрические фигуры на плоскости. Им сложнее представлять и изображать на чертежах пространственные фигуры. Поэтому возникает проблема выхода в пространство. </p>
<br><p><table>
<tr>
<td><img src="./images/pic_12.png"></td>
<td><img src="./images/pic_13.png"></td>
<td><img src="./images/pic_14.png"></td>
</tr>
<tr>
<td style="font-style: italic">В картине «Относительность» (1953 г.) действуют три перпендикулярных друг другу источника гравитации.</td>
<td style="font-style: italic">Литография «Водопад» (1961 г.) основана на «невозможном треугольнике» Пенроуза.</td>
<td style="font-style: italic">Коллаж из наиболее известных картин Маурица (Мориса) Эшера</td>
</tr>
</table>
</p>
<br>
<p><span style="font-style: italic">Третья особенность</span> заключена в интеграции пространственного и логического мышления, которая обеспечивает переход от трёхмерного образа пространственной фигуры к изучению математических отношений на плоскости.</p>
<div style="text-align: center">
    <div style="margin: 0 auto; width: 50%; background-color: lightgray; padding: 2vw; border: 2px solid lightskyblue; border-radius: 2vw;">
    <p style="font-weight: bold; text-align: left">ТЕОРЕМА ДЕЗАРГА</p>
    <p style="text-align: left">Пусть ABC и А'В'С - два треугольника (необязательно лежащие в одной плоскости), такие, что прямые АА',ВВ' и СС', соединяющие соответственные вершины треугольников, сходятся в одной точке S. Тогда точки пересечения соответственных сторон этих треугольников АВ и А'В', ВС и В'С', СА и С'А' лежат на одной прямой.</p>
</div>
</div>
<br><p><table style="margin: 0 auto">
<tr>
<td><img src="./images/pic_10.png"></td>
<td><img src="./images/pic_11.png"></td>
</tr>
</table>
</p>
<p>Перечисленные особенности необходимо учитывать при организации изучения теоретического материала курса и в процессе  формирования умений решения стереометрических задач.</p>
<p>
<ul>
<li>Как же в начале изучения геометрии в 10 классе организовать процесс формирования у обучающихся умений решения стереометрических задач?</li>
<li>Каким содержанием, ориентированным на формирование умений решения стереометрических задач, расширить учебный материал по геометрии? </li>
<li>Какие средства математики способствуют достижению требуемых результатов? Какие задачи можно использовать с этой целью? </li>
<li>Как организовать процесс формирования умений поиска решения задач, как важного этапа решения, чтобы он был более результативным?</li>
</ul>
</p>`
            }],
            contentAfter: [{
                type: "text",
                text: ``
            }]
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1012",
            title: "Практический модуль",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Приказ Министерства просвещения Российской Федерации от 31.05.2021 № 287 «Об утверждении федерального государственного образовательного стандарта основного общего образования» (Зарегистрирован Минюстом России 05.07.2021 № 64101).",
                "Приказ Министерства просвещения Российской Федерации от 18.07.2022 № 568 «О внесении изменений в федеральный государственный образовательный стандарт основного общего образования, утвержденный приказом Министерства просвещения Российской Федерации от 31 мая 2021 г. № 287» (Зарегистрирован Минюстом России 17.08.2022 № 69675).",
                "Приказ Министерства образования и науки Российской Федерации от 17 мая 2012 г. № 413 «Об утверждении федерального государственного образовательного стандарта среднего общего образования» (Зарегистрирован Минюстом России 7 июня 2012 г. № 24480).",
                "Приказ Министерства просвещения РФ от 12 августа 2022 г. № 732 «О внесении изменений в федеральный государственный образовательный стандарт среднего общего образования, утвержденный приказом Министерства образования и науки Российской Федерации от 17 мая 2012 г. № 413» (Зарегистрирован Минюстом России 12.09.2022 № 70034). ",
                "Приказ Министерства просвещения Российской Федерации от 16.11.2022 № 993 «Об утверждении федеральной образовательной программы основного общего образования» (Зарегистрирован Минюстом России 12 июля 2023 № 74223).",
                "Приказ Министерства просвещения Российской Федерации от 18 мая 2023 № 371 «Об утверждении федеральной образовательной программы среднего общего образования» (Зарегистрирован Минюстом России 12 июля 2023 № 74228). ",
                "Федеральная рабочая программа основного общего образования по учебному предмету «Математика». Базовый уровень. – М., 2023.",
                "Федеральная рабочая программа основного общего образования по учебному предмету «Математика». Углублённый уровень. – М., 2023.",
                "Федеральная рабочая программа среднего общего образования по учебному предмету «Математика». Базовый уровень. – М., 2023. ",
                "Федеральная рабочая программа среднего общего образования по учебному предмету «Математика». Углублённый уровень. – М., 2023. ",
                "«О стратегии развития информационного общества в Российской Федерации на 2017–2030 годы». Указ Президента Российской Федерации от 09.05.2017 г. № 203. ",
                "Концепция развития математического образования в Российской Федерации. Утверждена распоряжением Правительства Российской Федерации от 24 декабря 2013 г. № 2506-р. ",
                "Национальная программа «Цифровая экономика Российской Федерации». Утверждена Протоколом заседания президиума Совета при Президенте Российской Федерации по стратегическому развитию и национальным проектам от 4 июня 2019 г. № 7. ",
                "Федеральный проект «Цифровая образовательная среда» Минпросвещения России. ",
            ],
            historical: [
                "Рослова Л. О., Алексеева Е. Е., Буцко Е. В. Математика. Реализация требований ФГОС основного общего образования: методическое пособие для учителя / Л. О. Рослова, Е. Е. Алексеева, Е. В. Буцко; под ред. Л. О. Рословой. – Москва: ФГБНУ «Институт стратегии развития образования РАО», 2022. – 264 с.: [Электронный ресурс]. – URL: https://edsoo.ru/",
                "Рослова Л. О., Алексеева Е. Е., Буцко Е. В., Карамова И. И. Математика (углублённый уровень). Реализация требований ФГОС основного общего образования: методическое пособие для учителя / под ред. Л. О. Рословой. – Москва: ФГБНУ «Институт стратегии развития образования РАО», 2022. – 135 с.: [Электронный ресурс]. – URL: https://edsoo.ru/",
            ],
            sites: [
                "Math.ru – [Электронный ресурс]. – URL: https://math.ru",
                "Виртуальные лабораторные и практические работы на углубленном уровне среднего общего образования. – ФГБОУ «ИСРО РАО» – [Электронный ресурс]. – URL: https://content.edsoo.ru/lab/",
                "Информационно-поисковая система «Задачи по геометрии». – [Электронный ресурс]. – URL: https://zadachi.mccme.ru/2012/local.html",
                "Компьютер на уроке создание современной информационно-образовательной среды. – [Электронный ресурс]: режим доступа: http://seninvg07.narod.ru/index.htm",
                "Методические кейсы по математике. – ФГБОУ «ИСРО РАО». – https://content.edsoo.ru/case/subject/6/",
                "Образовательный центр «Сириус». – [Электронный ресурс]. – URL: https://sochisirius.ru/",
                "Портал «Единое содержание общего образования». – [Электронный ресурс]. – URL: https://edsoo.ru/",
                "Российская электронная школа. – [Электронный ресурс]. – URL: https://resh.edu.ru/",
                "Семинары «Методическая поддержка учителей математики при введении и реализации обновлённых ФГОС ООО и СОО». –  ФГБОУ «ИСРО РАО». – [Электронный ресурс]. – URL: https://edsoo.ru/Metodicheskaya_podderzhka_uchitelej_matematiki_pri_vvedenii_i_realizacii_obnovlennogo_FGOS_OOO.htm",
            ],
            dop: [
                "Гордин Р.К. Планиметрия. 7–9 классы. – 4-е изд. – Москва: МЦНМО, 2008",
                "Прасолов В.В. Задачи по планиметрии (в двух частях): учебное пособие – Москва: Наука. Физматлит, 1995",
                "Прасолов В.В., Шарыгин И.Ф. Задачи по стереометрии. – Москва: Наука. Гл. ред. физ. – мат. лит.,1989",
                "Сборник задач по математике для поступающих во втузы / В. К. Егерев, В. В. Зайцев, Б. А. Кордемский и др.; Под ред. М. И. Сканави. – Москва: ООО «Издательство “Мир и образование”»: ООО «Издательство “ОНИКС-ЛИТ”, 2013",
            ],
            filesToDownload: [
                {
                    link: "./files/add.pdf",
                    fileName: "Дополнительные материалы"
                }
            ]
        }
    ],
};
